import {takeEvery, put, race, take, delay, select} from 'redux-saga/effects';

import {sessionTimeout} from 'modules/authentication/actions';
import {rememberLocation, setApiToken} from 'modules/authentication/utils';
import {notifyUser} from 'modules/toast/actions';
import {accessTokenError, refreshAccessToken, receiveAccessToken, refreshTokenAndRetry, retryApiCall} from './actions';
import {pathSelector} from 'modules/rootSelectors';


export default function* () {
    console.log('starting api saga');
    yield takeEvery(refreshTokenAndRetry, refreshAndRetry)
}

function* refreshAndRetry(action) {

    yield put(refreshAccessToken(null, {application: 'uniportal'}));
    const result = yield race({
        success: take(receiveAccessToken),
        error: take(accessTokenError),
        timeout: delay(60000)
    });

    if (result.error || result.timeout) {
        const location = yield select(pathSelector);
        rememberLocation(location);
        yield put(notifyUser('Your session has expired', 'error'));
        yield delay(3000);
        yield put(sessionTimeout());
        return
    }

    const token = result.success.payload.data.token;
    const ttl = result.success.payload.data.ttl;

    setApiToken(token, ttl);

    yield put(retryApiCall(
        action.payload.endpoint,
        action.payload.method,
        action.payload.data,
        action.payload.actions,
        action.payload.context
    ));

}